import * as util from '../apiUtils';
import * as common from '../apiCommon';
import { PRICE_GROUP } from '../../constants/constant_doc_types';

export function fetchPriceGroupDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'price_group/dropdown';
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams,
  };

  return common.getDropdownList(app, { query });
}

export function savePriceGroup(app, dataToSave) {
  const { user = {}, data } = dataToSave;
  const doc = {
    doc_type: PRICE_GROUP,
    active: util.toBoolean(data.active),
    name: util.toStringText(data.name),
    description: util.toStringText(data.description),
  };

  return common.saveDoc(app, {
    source: data,
    doc,
    user,
  });
}

export function deletePriceGroup(app, data) {
  return common.deleteDoc(app, {
    id: data.id,
    docType: PRICE_GROUP,
  });
}

export function fetchPriceGroupById(app, params) {
  const { id } = params;
  const docType = PRICE_GROUP;
  return common.getDoc(app, { id, docType });
}
